import { useEffect } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import { HUB_SETTINGS_PAGES_PAGE_PATH, useGenerateCompanyPath } from '@/libs'
import { usePageQuery } from '@/layouts/pages/api/usePageQuery'
import { HubSettingsPageFieldsSkeleton, HubSettingsPageForm, useHubSettings } from '@/layouts/hub-settings/widgets'

export const HubPagesSettingsIndexPage = () => {
  const navigate = useNavigate()
  const { pages } = useHubSettings()
  const { generatePath } = useGenerateCompanyPath()
  const pageId = pages.primal[0]?.id || pages.others[0]?.id

  useEffect(() => {
    pageId && navigate(generatePath(HUB_SETTINGS_PAGES_PAGE_PATH, { pageId }), { replace: true })
  }, [pageId])

  return null
}

export const HubPagesSettingsPage = () => {
  const { pageId } = useParams() as { pageId: string }
  const { website } = useHubSettings()
  const { data: page } = usePageQuery(pageId)

  return (
    <div className="px-10">
      {(website && page && <HubSettingsPageForm website={website} page={page} />) || <HubSettingsPageFieldsSkeleton />}
    </div>
  )
}
